import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CheckoutResponse } from '~client/model/checkout-response';
import { ResponseEntity } from '~client/model/response-entity';
import { AssignedOfferGroupPurchaseRequest } from '~client/model/assigned-offer-group-purchase-request';
import { PurchaseResponse } from '~client/model/purchase-response';

/* User APIs pertaining to users purchasing/confirming Yoop directly from clients */
export class ClientGuestPurchaseController extends BaseController {
  /**
   * Validates that the assignment string is valid before the user can accept from a client.
   */
  public validateAssignment$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/clientGuest/userPurchase/public/validate', { assignmentString });
  }

  /**
   * Returns checkout information for credit card purchases from clients.
   */

  public checkout(assignmentString: string, paymentMethodId?: number): Promise<CheckoutResponse> {
    return this.get('/clientGuest/userPurchase/checkout', { assignmentString, paymentMethodId });
  }

  public checkoutPublic(assignmentString: string): Promise<CheckoutResponse> {
    return this.get('/clientGuest/userPurchase/public/checkout', { assignmentString });
  }

  /**
   * Confirms tokens from the client to the user. paymentMethodId is null when the Yoop is free.
   */
  public purchase$(request: AssignedOfferGroupPurchaseRequest): Observable<ResponseEntity> {
    return this.post$('/clientGuest/userPurchase/purchase', request);
  }
  public purchase(request: AssignedOfferGroupPurchaseRequest): Promise<PurchaseResponse> {
    return this.post('/clientGuest/userPurchase/purchase', request);
  }

  /**
   * Declines an offer group made to the user from client.
   */
  public decline$(assignmentString: string): Observable<ResponseEntity> {
    return this.get$('/clientGuest/userPurchase/public/decline', { assignmentString });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/client-guest-purchase-controller.ts